<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">Lista de Imóveis</h3>
            </div>
            <div class="col-6 text-right">
              <base-button type="primary" icon size="sm" @click="addImovel()">
                <span class="btn-inner--icon"
                  ><i class="fas fa-house"></i
                ></span>
                <span class="btn-inner--text">Novo Imóvel</span>
              </base-button>
            </div>
          </div>
        </template>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              class="select-primary pagination-select"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>

            <div>
              <base-input
                v-model="query"
                type="search"
                prepend-icon="fas fa-search"
                placeholder="Pesquisar..."
                clearable
              />
            </div>
          </div>

          <el-table
            class="table-responsive align-items-center table-flush"
            header-row-class-name="thead-light"
            :data="imovels"
            @sort-change="sortChange"
          >
            <div slot="empty" v-if="loading">
              <img src="/img/loading.gif" style="height: 100px; width: 100px" />
            </div>

            <el-table-column
              label="Cod. do Imóvel"
              min-width="90px"
              prop="codimovel"
              sortable="custom"
            />
            
            <el-table-column
              label="Endereço"
              min-width="300px"
              prop="logradourotipo.name"
            >
              <template slot-scope="scope">
                <div>
                  <div>
                    <span v-if="scope.row.logradourotipo.name != ''">
                      <small>
                      {{ scope.row.logradourotipo.name }}
                      </small>
                    </span>
                    <span v-if="scope.row.logradouro != ''">
                      <strong>
                      {{ scope.row.logradouro }}
                      </strong>
                    </span>
                    <span v-if="scope.row.numero != ''">
                      <strong>
                      , {{ scope.row.numero }}
                      </strong>
                    </span>
                    <span v-if="scope.row.bairro != ''">
                      <small>                      
                      - {{ scope.row.bairro }}
                      </small>
                    </span>
                    <span v-if="scope.row.bairro != ''">
                      
                      <small>
                      - {{ scope.row.bairro }}
                      </small>
                    </span>
                    <span v-if="scope.row.municipio.name != ''">
                      
                      <small>
                      {{ scope.row.municipio.name }} - {{ scope.row.municipio.uf }}
                      </small>
                    </span>
                  </div>
                  
                  <div
                    v-for="(proprietario, index) in scope.row.proprietarios"
                    :key="'tag' + index"
                    ><small>{{ proprietario.nome }} (Proprietário)</small></div
                  >
                </div>
              </template>
            </el-table-column>



            <el-table-column min-width="85px" align="center">
              <div slot-scope="{ row }" class="table-actions">
                <el-tooltip content="Editar" placement="top">
                  <a
                    type="text"
                    @click="editImovel(row)"
                    class="table-action"
                    data-toggle="tooltip"
                    style="cursor: pointer"
                  >
                    <i class="fas fa-user-edit"></i>
                  </a>
                </el-tooltip>
                <el-tooltip content="Remover" placement="top">
                  <a
                    type="text"
                    @click="deleteImovel(row)"
                    class="table-action"
                    data-toggle="tooltip"
                    style="cursor: pointer"
                  >
                    <i class="fas fa-trash"></i>
                  </a>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class="">
            <p class="card-category">
              Exibindo de {{ total ? from + 1 : 0 }} até {{ to }} de um total de
              {{ total }} registros.

              <span v-if="selectedRows.length">
                &nbsp; &nbsp; {{ selectedRows.length }} rows selected
              </span>
            </p>
          </div>
          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          />
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { BasePagination } from "@/components/";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import Vue from "vue";
import { cloneDeep } from "lodash";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

export default {
  layout: "DashboardLayout",

  components: {
    BasePagination,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
  },

  data() {
    return {
      query: null,
      imovels: [],
      navitem_at: 0,
      navitem_filtros: [{}],
      selectedRows: [],
      sort: "-created_at",

      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
      },

      total: 0,
      loading: true,
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },
  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      try {
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.navitem_filtros[this.navitem_at]
              ? this.navitem_filtros[this.navitem_at]
              : {}),
            ...(this.query ? { codimovel: this.query } : {}),
            ...(this.query ? { cep: this.query } : {}),
            ...(this.query ? { logradouro: this.query } : {}),
            ...(this.query ? { bairro: this.query } : {}),
            ...(this.query ? { numero: this.query } : {}),
            ...(this.query ? { complemento: this.query } : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
          include: "logradourotipo,municipio",
        };
        await this.$store.dispatch("imovels/list", params).then(() => {
          this.imovels = this.$store.getters["imovels/list"];
          this.total = this.$store.getters["imovels/listTotal"];
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, something went wrong!",
        });
      }
    },

    editImovel(row) {
      this.$router.push({
        name: "Edit Imovel",
        params: { id: row.id },
      });
    },
    async deleteImovel(row) {
      if (this.$isDemo == 1 && ["1", "2"].includes(row.id)) {
        this.$notify({
          type: "danger",
          message: "You are not allowed not change data of default imovels.",
        });
        return;
      }
      try {
        const confirmation = await swal.fire({
          title: `Deletar este imóvel?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sim, deletar!",
          cancelButtonText: "Não, manter",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-warning",
          }
        });

        if (confirmation.value === true) {
          await this.$store.dispatch("imovels/destroy", row.id);
          await this.getList();
          this.$notify({
            type: "success",
            message: "Imóvel Removido com sucesso.",
          });
        }
      } catch (error) {
        if (error.response.data.errors[0]) {
          this.$notify({
            type: "danger",
            message: "Este imóvel possui contrato ou orçamento associado.",
          });
        } else {
          this.$notify({
            type: "danger",
            message: "Oops, Algo deu errado!",
          });
        }
      }
    },
    addImovel() {
      this.$router.push({ name: "Add Imovel" });
    },
    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },
  },
};
</script>
